import { jsx as t, jsxs as d } from "react/jsx-runtime";
import r from "../../../node_modules/prop-types/index.es.js";
import { forwardRef as f } from "react";
import * as v from "./style.es.js";
import { NameAvatar as c, NameAvatarContainer as l, NameAvatarText as N } from "./style.es.js";
import { COMPONENT_SIZE as m } from "../../../constants/sizes.es.js";
const o = f(({
  name: p,
  rounded: s = !0,
  size: n = m.md
}, i) => {
  const [a, e] = p.split(" ");
  return /* @__PURE__ */ t(c, { size: n, className: "name-avatar-wrapper", rounded: s, ref: i, children: /* @__PURE__ */ t(l, { children: /* @__PURE__ */ d(N, { children: [
    (a == null ? void 0 : a[0]) || "",
    (e == null ? void 0 : e[0]) || ""
  ] }) }) });
}), A = {
  name: r.string.isRequired,
  size: r.oneOfType([r.oneOf(Object.values(m)), r.number]),
  rounded: r.bool
};
o.S = v;
o.displayName = "NameAvatar";
o.propTypes = A;
export {
  o as NameAvatar,
  A as nameAvatarPropTypes
};
//# sourceMappingURL=NameAvatar.es.js.map
